import { NavigationRoute, User } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import React from 'react'
import { View } from 'react-native'
import { PressableOpacity } from 'shared/components/pressable_opacity'
import { UserAvatar } from 'shared/components/user/user_avatar'

interface Props {
  user: User
  onPressUser: (route: NavigationRoute | undefined) => void
}

export default function UserCell({ user, onPressUser }: Props) {
  const styles = useStyles()

  return (
    <View key={user.id} style={styles.container}>
      <PressableOpacity
        style={styles.cellContainer}
        onPress={() => onPressUser(user.route)}
      >
        <UserAvatar size="large" user={user} />
        <Text style={styles.name} numberOfLines={1}>
          {user.firstName}
        </Text>
      </PressableOpacity>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    paddingHorizontal: 10,
    width: 95,
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  cellContainer: { alignItems: 'center', justifyContent: 'center' },
  name: {
    color: theme.colors?.black,
  },
}))
